// Custom error class for authentication errors
export class AuthenticationError extends Error {
  constructor(message: string = 'Your session has expired. Please log in again.') {
    super(message);
    this.name = 'AuthenticationError';
    Object.setPrototypeOf(this, AuthenticationError.prototype);
  }
}

// Helper function to check if an error is an authentication error
export function isAuthenticationError(error: any): boolean {
  return error instanceof AuthenticationError || 
         error?.name === 'AuthenticationError' ||
         (error?.message && (
           error.message.includes('401') ||
           error.message.includes('Token expired') ||
           error.message.includes('Invalid token') ||
           error.message.includes('Not logged in') ||
           error.message.includes('No authentication token')
         ));
}

// Helper function to extract auth error message from API response
export function extractAuthError(response: Response, errorText: string): string {
  if (response.status === 401) {
    try {
      const errorData = JSON.parse(errorText);
      if (errorData.detail) {
        if (errorData.detail.includes('expired')) {
          return 'Your session has expired. Please log in again to continue.';
        }
        if (errorData.detail.includes('Invalid token') || errorData.detail.includes('Invalid token')) {
          return 'Your session is no longer valid. Please log in again.';
        }
        return 'Please log in to continue.';
      }
    } catch {
      // If JSON parsing fails, use default message
    }
    return 'Your session has expired. Please log in again to continue.';
  }
  return errorText;
}

